<template>
  <v-container id="PointsAutoReloadSettings" fluid class="ml-md-12 my-6">
    <div class="body-heading-large mb-6">Auto-Reload Settings</div>
    <v-card width="100%" class="points-auto-reload-settings-section">
      <v-card-text class="px-0">
        <v-form v-model="isPointsAutoReloadSettingFormValid" ref="pointsAutoReloadForm" @submit.prevent="updatePointsAutoReloadSetting">
          <v-row class="mx-2">
            <v-col cols="12" md="1">
              <div class="subtitle-1">Status:</div>
              <v-switch v-model="newAutoReloadPointsInfo.is_auto_reload" @change="onIsAutoReloadChange" class="my-0"></v-switch>
            </v-col>
            <v-col cols="12" md="4">
              <div class="subtitle-1">Reload points:</div>
              <v-select :items="autoReloadPointsThresholdOptions" label="Points" dense outlined :disabled="!newAutoReloadPointsInfo.is_auto_reload" v-model="newAutoReloadPointsInfo.threshold" :menu-props="{ offsetY: true }" :rules="requiredFieldRules" @change="onPointsAutoReloadSettingsChange" />
            </v-col>
            <v-col cols="12" md="4">
              <div class="subtitle-1">When balance is below:</div>
              <v-select :items="autoReloadPointsOptions" label="Points" dense outlined :disabled="!newAutoReloadPointsInfo.is_auto_reload" v-model="newAutoReloadPointsInfo.amount" :menu-props="{ offsetY: true }" :rules="requiredFieldRules" @change="onPointsAutoReloadSettingsChange" />
            </v-col>
            <v-col cols="12" md="3">
              <div class="subtitle-1">Start date:</div>
              <v-menu ref="menu" v-model="isStartDatePickerOpen" :close-on-content-click="false" :disabled="!newAutoReloadPointsInfo.is_auto_reload" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined :disabled="!newAutoReloadPointsInfo.is_auto_reload" v-model="newAutoReloadPointsInfo.start_date" label="Start Date" append-icon="mdi-calendar" readonly v-on="on" required :rules="requiredFieldRules" @change="onPointsAutoReloadSettingsChange"></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="newAutoReloadPointsInfo.start_date"
                  :min="
                    this.$moment()
                      .toISOString(true)
                      .substr(0, 10)
                  "
                  @change="selectStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="12">
              <div class="red--text">*System will auto-reload points when uncompleted quests bring total below threshold</div>
            </v-col>
          </v-row>
          <v-btn text color="secondary" @click="cancel" v-if="hasPointsAutoReloadSettingsChanged">Cancel</v-btn>
          <v-btn color="secondary" type="submit" :disabled="!canSubmit" v-if="hasPointsAutoReloadSettingsChanged">
            Save
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: "PointsAutoReloadSettings",
    data() {
      return {
        autoReloadPointsInfo: {},
        newAutoReloadPointsInfo: {
          is_auto_reload: undefined,
          amount: null,
          threshold: null,
          start_date: null,
        },
        autoReloadPointsOptions: [
          {
            text: "1,000",
            value: 1000,
          },
          {
            text: "2,000",
            value: 2000,
          },
          {
            text: "3,000",
            value: 3000,
          },
          {
            text: "4,000",
            value: 4000,
          },
          {
            text: "5,250",
            value: 5000,
          },
          {
            text: "11,000",
            value: 10000,
          },
        ],
        autoReloadPointsThresholdOptions: [
          {
            text: "1,000",
            value: 1000,
          },
          {
            text: "2,000",
            value: 2000,
          },
          {
            text: "3,000",
            value: 3000,
          },
          {
            text: "4,000",
            value: 4000,
          },
          {
            text: "5,250",
            value: 5000,
          },
          {
            text: "11,000",
            value: 10000,
          },
        ],
        isStartDatePickerOpen: false,
        requiredFieldRules: [(v) => !!v || "Field is required"],
        isPointsAutoReloadSettingFormValid: false,
        hasPointsAutoReloadSettingsChanged: false,
      };
    },

    computed: {
      canSubmit() {
        if (this.$validator.isUndefined(this.newAutoReloadPointsInfo.is_auto_reload)) {
          return false;
        } else if (this.newAutoReloadPointsInfo.is_auto_reload && !this.isPointsAutoReloadSettingFormValid) {
          return false;
        } else {
          return true;
        }
      },
    },

    methods: {
      onIsAutoReloadChange() {
        this.newAutoReloadPointsInfo = this.$formatter.extend(this.newAutoReloadPointsInfo, {
          amount: null,
          threshold: null,
          start_date: null,
        });

        if (this.$refs.pointsAutoReloadForm) {
          this.$refs.pointsAutoReloadForm.resetValidation();
        }

        this.onPointsAutoReloadSettingsChange();
      },

      selectStartDate(date) {
        this.$refs.menu.save(date);
        this.onPointsAutoReloadSettingsChange();
      },

      updatePointsAutoReloadSetting() {
        this.$store.commit("setLoadingStatus", true);

        if (!this.newAutoReloadPointsInfo.is_auto_reload) {
          this.newAutoReloadPointsInfo.start_date = "1970-01-01";
        }
        this.$http
          .put("/parents", {
            reload_settings: this.newAutoReloadPointsInfo,
          })
          .then((response) => {
            this.hasPointsAutoReloadSettingsChanged = false;
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: this.$formatter.getErrorMsg(error),
              type: "error",
            });
            this.hasPointsAutoReloadSettingsChanged = false;
            this.$store.commit("setLoadingStatus", false);
          });
      },

      cancel() {
        this.newAutoReloadPointsInfo = this.$formatter.extend(this.autoReloadPointsInfo);
        this.hasPointsAutoReloadSettingsChanged = false;
      },

      onPointsAutoReloadSettingsChange() {
        this.hasPointsAutoReloadSettingsChanged = true;
      },
    },

    created() {
      this.$store.commit("setLoadingStatus", true);

      this.$http
        .get("/profile")
        .then((response) => {
          if (response && response.data && response.data.profile && response.data.profile.reload_settings) {
            if (!response.data.profile.reload_settings.is_auto_reload) {
              this.autoReloadPointsInfo = {
                is_auto_reload: undefined,
                amount: null,
                threshold: null,
                start_date: null,
              };
              this.newAutoReloadPointsInfo = this.$formatter.merge({}, this.autoReloadPointsInfo);
            } else {
              this.autoReloadPointsInfo = this.$formatter.merge({}, response.data.profile.reload_settings);
              this.newAutoReloadPointsInfo = this.$formatter.extend(response.data.profile.reload_settings);
            }
          } else {
            this.$store.commit("setError", {
              message: "Could not retrieve user's points auto-reload settings information, please try again later",
              type: "error",
            });
          }

          this.$store.commit("setLoadingStatus", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: "Could not retrieve user's points auto-reload settings information, please try again later",
            type: "error",
          });

          this.$store.commit("setLoadingStatus", false);
        });
    },
  };
</script>

<style lang="scss" scoped>
  .points-auto-reload-settings-section {
    overflow-wrap: normal !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Points/PointsAutoReloadSettings.vue